import { useState } from 'react';
import { EventColumn } from './EventColumn';

interface TogglableEventColumnProps {
  className?: string;
}

export const TogglableEventColumn = ({
  className = '',
}: TogglableEventColumnProps) => {
  const [isClosedExpanded, setIsClosedExpanded] = useState(false);

  const handleToggle = () => {
    setIsClosedExpanded(!isClosedExpanded);
  };

  return (
    <div className={`h-full flex flex-col ${className}`}>
      {/* In Progress Section */}
      <div className={isClosedExpanded ? 'flex-shrink-0' : 'flex-1'}>
        <EventColumn
          title="In Progress"
          eventType="in_progress"
          limit={isClosedExpanded ? 1 : undefined}
          isTogglable={true}
          isExpanded={!isClosedExpanded}
          onToggle={handleToggle}
          showMoreIndicator={isClosedExpanded}
        />
      </div>

      {/* Closed Section */}
      <div className={`${isClosedExpanded ? 'flex-1' : 'flex-shrink-0'}`}>
        <EventColumn
          title="Closed"
          eventType="closed"
          limit={isClosedExpanded ? undefined : 1}
          isTogglable={true}
          isExpanded={isClosedExpanded}
          onToggle={handleToggle}
          showMoreIndicator={!isClosedExpanded}
        />
      </div>
    </div>
  );
};
